"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getPositionCompensation = function (position, triggerEl, arrowEl) {
    var _a, _b;
    if (!triggerEl || !arrowEl)
        return;
    var arrowSide = arrowEl.clientWidth;
    var arrowDiagonal = Math.sqrt(arrowSide * arrowSide * 2);
    var arrowOffsetValue = [
        "bottom-start",
        "bottom-end",
        "top-start",
        "top-end",
    ].includes(position)
        ? Math.min(arrowEl.offsetLeft, (((_a = arrowEl.offsetParent) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) -
            arrowEl.offsetLeft -
            arrowSide)
        : Math.min(arrowEl.offsetTop, (((_b = arrowEl.offsetParent) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0) -
            arrowEl.offsetTop -
            arrowSide);
    var compensation = { x: 0, y: 0 };
    var shouldCompensateX = triggerEl.clientWidth < arrowOffsetValue * 2 + arrowDiagonal;
    var shouldCompensateY = triggerEl.clientHeight < arrowOffsetValue * 2 + arrowDiagonal;
    var fullOffset = arrowOffsetValue * 2 + arrowDiagonal;
    if (shouldCompensateX && position) {
        if (["bottom-start", "top-start"].includes(position)) {
            compensation.x = (fullOffset / 2 - triggerEl.clientWidth / 2) * -1;
        }
        else if (["bottom-end", "top-end"].includes(position)) {
            compensation.x = fullOffset / 2 - triggerEl.clientWidth / 2;
        }
    }
    if (shouldCompensateY && position) {
        if (["start-top", "end-top"].includes(position)) {
            compensation.y = (fullOffset / 2 - triggerEl.clientHeight / 2) * -1;
        }
        else if (["end-bottom", "start-bottom"].includes(position)) {
            compensation.y = fullOffset / 2 - triggerEl.clientHeight / 2;
        }
    }
    return compensation;
};
exports.default = getPositionCompensation;
